import { ViewParameterList } from './ViewParameterList';
var MenuRoute = /** @class */ (function () {
    /**
     * Creates a menu route with view parameters specified.
     * @param baseRoute Path and component
     * @param menuParams Other menu options.
     * @param viewParams View parameter values.
     */
    function MenuRoute(baseRoute, menuParams, viewParams) {
        var _this = this;
        Object.getOwnPropertyNames(baseRoute).forEach(function (propertyName) {
            // @ts-ignore 
            _this[propertyName] = baseRoute[propertyName];
        });
        Object.getOwnPropertyNames(menuParams).forEach(function (propertyName) {
            // @ts-ignore 
            _this[propertyName] = menuParams[propertyName];
        });
        this.basePath = this.path;
        if (viewParams) {
            this.path = ViewParameterList.getPathForValues(this.basePath, baseRoute.component.params, viewParams);
        }
    }
    return MenuRoute;
}());
export { MenuRoute };
